// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3KCCN","footer":"ModalUpdate_footer__2etF9"};